// Beach colours, shared by the land tile's shore band (tileGeometry.ts) and the ramp (ShorelineMesh.tsx) so the
// sand continues across the plateau edge without a seam.

/** Dry sand (what SHORE_COLOR.default always was). */
export const SAND_DRY = '#dcc793';
/** Wet sand: darker and a touch bluer. */
export const SAND_WET = '#b4a98a';
/** Rock face / shingle on cliff coasts. */
export const ROCK_DARK = '#5d5a54';
export const ROCK_LIGHT = '#8d887c';
